import { CheckboxFieldView } from '../checkboxField/views';
import { TemperatureFieldView } from '../temperatureField/views';
import { NA } from '../constants';
import { BaseFieldView } from '../BaseField/views';
import { MobileEquipmentTemperatureField, MobileIngredientTemperatureField } from './models';
import LinkIcon from '@mui/icons-material/Link';
import { default as sensorUtils } from '../../../../backbone-unorganized/shared/sensors/util';
import { isWeb, isWindows } from '../../../../shared/utils/is';
import { hideLoadingDialog } from '../../../../shared/utils/notifications';

export const IngredientEquipmentFollowUpActionsListItem = CheckboxFieldView.extend({
    template: '#tpl_ingredient_equipment_follow_up_actions_list_item',
    className: 'form-field dependent_field',

    getTemplate: function () {
        return this.template;
    },

    onRender: function () {
        IngredientEquipmentFollowUpActionsListItem.__super__?.onRender?.apply(this, arguments);

        if (typeof this.model.get('value') === 'boolean' && !this.model.is_valid) {
            this.$el.addClass('invalid');
        }
    }
});

export const IngredientEquipmentFollowUpActionsList = Backbone.Marionette.CollectionView.extend({
    itemView: IngredientEquipmentFollowUpActionsListItem,
    collection: null, // FollowUpActionFields
    tagName: 'ul',

    handle_change: function () {} // don't re-render on save; sub-view's will do that themselves
});

export const IngredientEquipmentTemperatureFieldItemView = TemperatureFieldView.extend({
    tagName: 'li',
    template: '#tpl_ingredient_equipment_temperature_item_field',

    className: function () {
        return this.model.get('retemp_attempt') ? 'retemp-field' : '';
    },

    regions: {
        r_ingredient_equipment_follow_up_actions: '.ingredient_equipment_follow_up_actions'
    },

    events: _.extend(
        {
            'click .ingredient_equipment_temperature_na': 'save_na_value'
        },
        TemperatureFieldView.prototype.events
    ),

    templateHelpers: function () {
        const sensorFields = this.getSensorFields();
        this.model.set_acceptance_value();
        return $.extend(IngredientEquipmentTemperatureFieldItemView.__super__.templateHelpers.apply(this, arguments), {
            retemp_attempt: this.model.get('retemp_attempt') || null,
            item_name:
                this.model.get('type') === 'ingredient_temperature'
                    ? this.model.get('name')
                    : this.model.get('model_name'),
            show_na_btn: this.model.get('allow_na'),
            pass_range_instructions: this.model._pass_range_instructions,
            ...sensorFields
        });
    },

    getTemplate: function () {
        return this.template;
    },

    on_change_action: function (model) {
        if (this.model.get('follow_up_actions')) {
            return;
        }

        // proceed to the next field with bluetooth probe
        if (model.changed.value === null || model.changed.value === undefined) {
            return;
        }
        const next_model = model.get_next_visible_temp();

        // make sure the next model exists and it is the same type as what are just updated
        if (!next_model || ['', null].indexOf(next_model.get('value')) === -1) {
            return;
        }

        const next_id = next_model.get('id');
        const collection = next_model.collection;
        const next_parent_id = collection.parent_field_id;

        if ($f.utils.is_nil(next_parent_id)) {
            return;
        }

        const $target = $(`#field_${next_parent_id} #field_${next_id}`);
        if (!$target) {
            return;
        }
        const $input = $target.find('.fake_input');
        if (!$input) {
            return;
        }
        $input.focus().click();
        // after this sets a value, the delete box comes up which changes the height of the current element,
        // by delaying shortly we move down the full height of this element
        setTimeout(this._scroll_down_one_field.bind(this), 100);
    },

    save_na_value: function (event) {
        // are they clicking the same thing again
        const new_value = $(event.target).attr('value');
        if (this.model.get('value', '') === new_value) {
            return false;
        }

        this.model.set({ value: new_value });
        return false;
    },

    onRender: function () {
        if (this.model.get('value') === NA) {
            // Highlight na button if set
            this.$el.find('.ingredient_equipment_temperature_na').addClass('selected');
        }

        if ($f.active_company.has_feature('sensor_equipment_readings') && this.model.get('sensor')) {
            const elem = this.$('.sensor_link')[0];

            window.mountReactJSX(elem, () => <LinkIcon />);
        }

        const follow_up_actions = this.model.get('follow_up_actions');

        if (follow_up_actions?.length > 0 && !this.isClosed) {
            this.r_ingredient_equipment_follow_up_actions.show(
                new IngredientEquipmentFollowUpActionsList({
                    collection: follow_up_actions
                })
            );
        }
    },

    // We explicitly define our template, so we don't want BaseField to validate it
    validate_template: () => {},

    _should_force_temperature_probe: function () {
        if (isWindows() || isWeb()) {
            return false;
        }

        return this.model.collection.form_collection.metadata.get('is_force_probe_input');
    },

    getSensorFields: function () {
        const sensor = this.model.get('sensor');
        if (!$f.active_company.has_feature('sensor_equipment_readings') || !sensor) {
            return { has_sensor: false };
        }
        const placement = sensor.get('placement');

        const isValidSensorTemperatureReading = sensorUtils.isValidSensorTemperatureReading(
            sensor.get('is_online'),
            sensor.get('last_reading_date'),
            sensor.get('last_reading_value')
        );

        if (isValidSensorTemperatureReading) this._set_value(sensor.get('last_reading_value'));

        return {
            has_sensor: true,
            sensor_name: sensor.get('name'),
            battery: sensor.get('battery'),
            timestamp: sensor.get('last_reading_date')
                ? sensorUtils.get_formatted_sensor_timestamp({
                      time_zone: $f.active_user.get('time_zone'),
                      timestamp: sensor.get('last_reading_date'),
                      format: $f.utils.DATE_AND_TIME_FMT
                  })
                : null,
            placement: placement ? placement.name : null,
            is_valid_sensor_temperature_reading: isValidSensorTemperatureReading,
            is_online: isValidSensorTemperatureReading ? sensor.get('is_online') : false
        };
    },

    click_probe_input: function (event) {
        const sensorInfo = this.getSensorFields();

        if (!sensorInfo.has_sensor || !sensorInfo.is_valid_sensor_temperature_reading)
            IngredientEquipmentTemperatureFieldItemView.__super__?.click_probe_input?.apply(this, arguments);

        return false;
    },

    retry_connect: function (event) {
        const sensorInfo = this.getSensorFields();

        if (!sensorInfo.has_sensor || !sensorInfo.is_valid_sensor_temperature_reading)
            IngredientEquipmentTemperatureFieldItemView.__super__?.retry_connect?.apply(this, arguments);

        return false;
    }
});

/**
 *  Composite for ingredient temperature field title and the collection of ingredients
 */
export const IngredientEquipmentTemperatureFieldList = Backbone.Marionette.CollectionView.extend({
    itemView: IngredientEquipmentTemperatureFieldItemView,
    tagName: 'ul',
    collection: null // IngredientTemperatures | EquipmentTemperatures
});

export const IngredientEquipmentTemperatureFieldView = BaseFieldView.extend({
    template: '#tpl_ingredient_equipment_temperature_field',
    tagName: 'li',
    model: null, // MobileIngredientTemperatureField | MobileEquipmentTemperatureField

    regions: {
        r_ingredient_equipment_temperatures_list: '.ingredient_equipment_temperatures_list'
    },

    events: {
        'click .df-arrow-down': 'toggle_ingredient_equipment_temperatures',
        'click .df-arrow-up': 'toggle_ingredient_equipment_temperatures'
    },

    templateHelpers: function () {
        return $.extend(IngredientEquipmentTemperatureFieldView.__super__.templateHelpers.apply(this, arguments), {
            is_collapsed: this.is_collapsed
        });
    },

    /**
     * Because our IngredientEquipmentTemperatures validate and highlight themselves
     * when things go wrong, we don't need to highlight everything like other fields. Instead,
     * let's just highlight the field name and let the sub-models highlight which individual
     * emails are invalid.
     */
    on_model_invalid: function (model, error) {
        this.model.is_valid = false;
        this.trigger('request_error_wizard_recalculation', this.model);

        this.$el.find('.field_title').addClass('invalid');
    },

    on_model_valid: function (model) {
        this.$el.removeClass('invalid');
        this.model.is_valid = true;

        this.$el.find('.field_title').removeClass('invalid');
        this.trigger('request_error_wizard_recalculation', this.model);
    },

    getTemplate: function () {
        return this.template;
    },

    initialize: function (options) {
        const _this = this;
        const account_field = this.model.collection.findWhere({ type: 'account' });
        if (!account_field) {
            return;
        }

        options = options || {};
        $.extend(this, options);

        if (this.form_collection.has_been_submitted()) {
            this.model.temperature_collection.set_submitted_values(this.model.get('value') || []);
            hideLoadingDialog();
        }

        if (this.form_collection.is_draft() || this.model.get('value').length > 0) {
            this.model.temperature_collection.set_saved_values(this.model.get('value') || []);
        }

        IngredientEquipmentTemperatureFieldView.__super__.initialize.apply(this, arguments);

        if (this.model instanceof MobileIngredientTemperatureField) {
            this.listenTo(account_field, 'change:ingredientCollection', (ingredientLocation, silent) =>
                this.model.change_ingredient_location(ingredientLocation, account_field.get('value'), silent)
            );
        }
        if (this.model instanceof MobileEquipmentTemperatureField) {
            this.listenTo(account_field, 'change:equipmentCollection', (equipmentLocation, silent) =>
                this.model.change_equipment_location(equipmentLocation, account_field.get('value'), silent)
            );
        }

        this.listenTo(this.model.temperature_collection, 'change add remove', () => {
            _this.save_value();
            _this.render();
        });
    },

    onRender: function () {
        this.r_ingredient_equipment_temperatures_list.show(
            new IngredientEquipmentTemperatureFieldList({
                collection: this.model.temperature_collection
            })
        );
    },

    save_value: function () {
        this.model.save_value();
    },

    toggle_ingredient_equipment_temperatures: function () {
        this.is_collapsed = !this.is_collapsed;
        this.render();
    },

    handle_change: function () {} // don't re-render on save; sub-view's will do that themselves
});
